import React from "react";
import styled from "styled-components";
import { breakpoint, theme } from "@utilities";

export interface CommissionBannerProps {
    learnMoreHref: string;
}

export const CommissionBanner: React.FC<CommissionBannerProps> = ({ learnMoreHref }) => (
    <BannerWrapper>
        <img src="/images/commission.svg" alt="Commission icon" style={{ width: 40, height: 40 }} />
        <BannerText>
            <Headline>Get paid for every bookings you make</Headline>
            <Subtext>Book and Earn Commission</Subtext>
        </BannerText>
        <LearnMore href={learnMoreHref}>Learn More</LearnMore>
    </BannerWrapper>
);

const BannerWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
    border: 1px solid ${theme.colors.purple};
    border-radius: 8px;
    background: linear-gradient(
        90deg,
        ${theme.gradients.bannerCommission[0]} 0%,
        ${theme.gradients.bannerCommission[1]}
    );
    padding: 12px;
    margin-top: 0;
    margin-bottom: 32px;
    margin-left: auto;
    margin-right: auto;
    min-height: 66px;
    box-sizing: border-box;
    font-family: "Poppins";

    ${breakpoint.breakOnlyMobile`
        margin: 0 16px 32px 16px;
    `}
    ${breakpoint.breakMobileMedium`
        width: ${(props) => props.theme.widths.wide_700};
    `}
    ${breakpoint.breakTablet`
        width: ${(props) => props.theme.widths.wide_700};   
    `}
    ${breakpoint.breakIpadPro`
        width: ${(props) => props.theme.widths.wide_850}; 
    `}
    ${breakpoint.breakLarge`
        width: ${(props) => props.theme.widths.wide_1110};
    `}
`;

const BannerText = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    gap: 4px;
`;

const Headline = styled.div`
    font-size: 14px;
    line-height: 120%;
    font-weight: 600;
    color: #4b4b4b;
`;

const Subtext = styled.div`
    font-size: 14px;
    line-height: 120%;
    color: #4b4b4b;
    font-weight: 400;
`;

const LearnMore = styled.a`
    color: #7257ff;
    font-weight: 500;
    font-size: 14px;
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.2s;
    &:hover {
        text-decoration: underline;
    }
`;
